import React from "react";
import { useNavigate } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";
import Topbar from "Components/Topbar/Topbar";
import type { User as BackendUser } from "../../types/user";
import "./ComingSoonPage.css";

interface ComingSoonPageProps {
  user: BackendUser;
  title: string;
  description: string;
  icon: React.ReactNode;
  accentColor: string;
}

const STEPS = [
  "Conception & architecture",
  "Développement des fonctionnalités",
  "Tests & validation",
  "Déploiement",
];

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({
  user,
  title,
  description,
  icon,
  accentColor,
}) => {
  const navigate = useNavigate();

  return (
    <div className="cs-page">
      <Topbar
        title={title}
        userName={user.username}
        onLogout={() => navigate("/")}
        user={user}
      />

      <div className="cs-content">
        {/* Back */}
        <button className="cs-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Retour
        </button>

        {/* Main card */}
        <div className="cs-card">
          {/* Decorative blobs */}
          <div
            className="cs-blob cs-blob-1"
            style={{ background: `${accentColor}18` }}
          />
          <div
            className="cs-blob cs-blob-2"
            style={{ background: `${accentColor}0e` }}
          />

          <div className="cs-card-inner">
            {/* Icon */}
            <div
              className="cs-icon-ring"
              style={{
                background: `${accentColor}15`,
                boxShadow: `0 0 0 12px ${accentColor}08`,
              }}
            >
              <div
                className="cs-icon-wrapper"
                style={{ background: accentColor }}
              >
                {icon}
              </div>
            </div>

            {/* Badge */}
            <div className="cs-badge">
              <Construction size={13} />
              En cours de développement
            </div>

            {/* Text */}
            <h1 className="cs-title">{title}</h1>
            <p className="cs-desc">{description}</p>

            {/* Divider */}
            <div className="cs-divider" />

            {/* Progress steps */}
            <div className="cs-steps">
              <p className="cs-steps-label">Étapes de développement</p>
              <div className="cs-steps-list">
                {STEPS.map((step, i) => (
                  <div className="cs-step" key={i}>
                    <div
                      className={`cs-step-dot ${i === 0 ? "cs-step-dot--active" : ""}`}
                      style={i === 0 ? { background: accentColor, boxShadow: `0 0 0 4px ${accentColor}25` } : {}}
                    />
                    <span
                      className={`cs-step-label ${i === 0 ? "cs-step-label--active" : ""}`}
                      style={i === 0 ? { color: accentColor } : {}}
                    >
                      {step}
                    </span>
                    {i === 0 && (
                      <span
                        className="cs-step-badge"
                        style={{ background: `${accentColor}18`, color: accentColor }}
                      >
                        En cours
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
